import { Injectable } from '@angular/core';

export const USER_KEY = 'authenticated-user';
export const IAM_PROFILE_KEY = 'iam-user-profile';
export const LEGACY_USER_ID_KEY = 'userid';
export const USER_PLANT = 'authenticated-user-plant';
export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh-token';
export const ACCESS_TOKEN_EXPIRES_AT = 'access-token-expires-at';
export const REFRESH_TOKEN_EXPIRES_AT = 'refresh-token-expires-at';
export const INVERTER_TYPE = 'inverter-type';
export const PLANT_TYPE = 'plant-type';
export const SELECTED_PLANT_ID = 'selected-plant-id';
export const SELECTED_PLANT_NAME="selected-plant-name"
export const ACTIVE_SESSION = 'session-active';
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  get(key: string) {
    return localStorage.getItem(key);
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  clean(): void {
    localStorage.clear();
  }

  /**
   * Set object, json and class instance
   * @param key
   * @param value
   */
  setObject(key: string, value: object) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *
   * @param key Fetch json, object or interface
   * @returns
   */
  getObject(key: string) {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key)!);
    }
    return {};
  }
}
